'use strict'

const brandIcon = [
  { icon: '1', name: 'bmw' },
  { icon: '2', name: '기아' },
  { icon: '3', name: '닛산' },
  { icon: '4', name: '닷지' },
  { icon: '5', name: '도요타' },
  { icon: '6', name: '랜드로버' },
  { icon: '7', name: '렉서스' },
  { icon: '8', name: '르노삼성' },
  { icon: '9', name: '링컨' },
  { icon: '10', name: '미니' },
  { icon: '11', name: '벤츠' },
  { icon: '12', name: '볼보' },
  { icon: '13', name: '쉐보레' },
  { icon: '14', name: '쌍용' },
  { icon: '15', name: '아우디' },
  { icon: '16', name: '인피니티' },
  { icon: '17', name: '재규어' },
  { icon: '18', name: '제네시스' },
  { icon: '19', name: '지프' },
  { icon: '20', name: '캐딜락' },
  { icon: '21', name: '크라이슬러' },
  { icon: '22', name: '포드' },
  { icon: '23', name: '폭스바겐' },
  { icon: '24', name: '푸조' },
  { icon: '25', name: '현대' },
  { icon: '26', name: '혼다' }
]

export default brandIcon
